<template>
  <div class="bg">
    <Header1></Header1>
    <el-dialog title="新闻详情"
               :visible.sync="dialogTableVisible"
               style="text-align: left; ">
      <p class="dialogtitle">{{detail.title}}</p>
      <p class="dialogtitle1">
        <span>报道人: {{detail.reporter}}</span>
        <span>报道时间: {{detail.reportdate}}</span>
        <span>报道部门:{{detail.department}}</span>
      </p>
      <p class="dialogtitle4"
         v-html="detail.newscontent"></p>
    </el-dialog>
    <div class="newheader">当前位置：<span style="cursor: pointer"
            @click="homePage">首页</span> > <router-link to="/newsPage">新闻列表</router-link> > 新闻详情</div>
    <div class="bg-box">
      <div class="content">
        <div v-for="(item , index) in newsList"
             @click="newsDetail(item)"
             style="cursor: pointer;border-bottom: 1px solid #e9e9eb; margin-bottom: 15px;display: block">
          <h6 class="contentitem">{{item.title}}</h6>
          <p class="contentitem1">新闻详情</p>
          <p class="contentitem2">{{item.reportdate}}</p>
        </div>
      </div>
      <Pager :page="page"
             @load="getNews"></Pager>
    </div>
    <!-- <Foot></Foot> -->
  </div>
</template>

<script>
import {
  request
} from '../API/ApiUrl.js';
import Header1 from '../components/Header1.vue';
import Pager from '../components/Pager'
export default {
  components: {
    Header1,
    // Foot,
    Pager
  },
  name: "news-page",
  data () {
    return {
      page: {
        size: 10,
        number: 1,
        content: [],
        totalElements: 0,
        fun: 'getNews'
      },
      dialogTableVisible: false,
      newsList: [],
      detail: {}
    }
  },
  mounted () {
    this.getNews();
    this.addVisit();
  },

  methods: {
    //增加点击量
    addVisit () {
      request('/apiVisit/addVisitData', {
        module: 101
      }).then(res => {

      })
    },
    //获取新闻内容
    getNews () {
      request('/apiNews/dataNewsList', {
        offset: this.page.number,
        limit: this.page.size,
        text1: 1
      }).then(res => {
        //console.log(res);
        if (res.code === 200) {
          this.newsList = res.data.result;
          this.page.totalElements = res.data.count;
        }
      })
    },
    //跳转到首页
    homePage () {
      this.$router.push("/index");
    },
    newsDetail (item) {
      //console.log(item);
      this.detail = item;
      window.open('#/newsPage2?id=' + item.id , '_blank')
    },
  }

}
</script>

<style scoped>
.newheader a {
  color: #51cfc1;
}
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.bg {
  width: 100%;
  height: 100%;
}

.bg-box {
  width: 60%;
  margin: -1px auto;
}

.contentitem {
  padding: 2px 10px;
  margin-left: 10px;
  color: #12837b;
  font-size: 14px;
  cursor: pointer;
}

.contentitem1 {
  padding: 2px 10px;
  margin: 10px;
  color: #519b96;
  font-size: 13px;
  width: 40%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.contentitem2 {
  padding: 2px 10px;
  margin: 10px;
  color: #519b96;
  font-size: 13px;
  width: 48%;
  display: inline-block;
  text-align: right;
}

.content {
  width: 100%;
  margin-top: 10px;
}

.newheader {
  padding: 10px 0;
  font-size: 12px;
  font-weight: bold;
  color: #51cfc1;
  margin-top: 15px;
  width: 60%;
  margin: auto;
  line-height: 45px;
  border-bottom: 1px solid #d7ecec;
  margin-bottom: 25px;
}

.el-dialog__body {
  padding: 20px 26px;
  color: #606266;
  font-size: 14px;
}

.dialogtitle {
  font-size: 17px;
  font-weight: bold;
  color: #17847b;
  line-height: 30px;
  text-indent: 25px;
  margin-bottom: 20px;
}

.dialogtitle1 {
  text-indent: 15px;
  font-size: 12px;
  /* font-weight: bold; */
  color: #17847b;
  line-height: 21px;
  margin-bottom: 10px;
}

.dialogtitle2 {
  text-indent: 25px;
  color: #17847b;
  line-height: 26px;
}

.dialogtitle3 {
  text-indent: 25px;
  color: #17847b;
  line-height: 26px;
}

.dialogtitle4 {
  /* text-indent: 33px;
		font-size: 14px;
		color: #17847b;
		line-height: 30px;
		padding: 0 30px; */
}

/* .dialogtitle4>>>h1,h2,h3,h4,h5,h6{
	  font-family: "PT Sans","SF UI Display", ".PingFang SC","PingFang SC", "Neue Haas Grotesk Text Pro", "Arial Nova", "Segoe UI", "Microsoft YaHei", "Microsoft JhengHei", "Helvetica Neue", "Source Han Sans SC", "Noto Sans CJK SC", "Source Han Sans CN", "Noto Sans SC", "Source Han Sans TC", "Noto Sans CJK TC", "Hiragino Sans GB", sans-serif;
	  text-rendering:optimizelegibility;margin-bottom:1em;font-weight:bold; line-height: 1.8rem;} */
.el-dialog__body {
  color: #606266;
  font-size: 14px;
}
</style>
